/* src/components/customGame/player/CustomGamePaused.js */
import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faStopCircle, faHourglassHalf } from '@fortawesome/free-solid-svg-icons';

const CustomGamePaused = ({ onResume, onEndGame }) => {
    return (
        <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-75 backdrop-blur-md z-30 animate-[fadeIn_0.2s_ease-out]">
            <div className="bg-white p-6 sm:p-8 rounded-xl shadow-2xl text-center w-full max-w-sm mx-4 border border-gray-200">
                <FontAwesomeIcon icon={faHourglassHalf} className="text-5xl text-indigo-500 mb-5 animate-pulse" />

                <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-6">
                    Game Paused
                </h2>

                <div className="space-y-3 sm:space-y-4">
                    <button
                        onClick={onResume}
                        className="w-full px-6 py-3 bg-green-500 text-white font-semibold rounded-lg hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors text-base sm:text-lg flex items-center justify-center shadow-md"
                        aria-label="Resume Game"
                    >
                        <FontAwesomeIcon icon={faPlay} className="mr-2 h-5 w-5" />
                        Resume
                    </button>

                    <button
                        onClick={onEndGame}
                        className="w-full px-6 py-2.5 bg-red-500 text-white font-medium rounded-lg hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors text-sm sm:text-base flex items-center justify-center shadow"
                        aria-label="End Game and View Results"
                    >
                        <FontAwesomeIcon icon={faStopCircle} className="mr-2 h-4 w-4" />
                        End Game & See Results
                    </button>
                </div>
                <p className="text-xs text-gray-500 mt-6">
                    Your progress is saved while paused.
                </p>
            </div>
        </div>
    );
};

CustomGamePaused.propTypes = {
    onResume: PropTypes.func.isRequired,
    onEndGame: PropTypes.func.isRequired,
};

export default CustomGamePaused;